import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta14({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['a) Proporcionarle un sistema de nomenclatura para organizar archivos y una guía para priorizar tareas.', 'c) Ofrecerle capacitación en herramientas de productividad y establecer objetivos claros con plazos específicos.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		array.sort();
		setSeleccionada(array);
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta14', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta14', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(15);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>14.</div> Adrían es un Asesor destacado en conocimientos técnicos, pero ha recibido retroalimentación sobre su falta de organización en la gestión de clientes. Constantemente pierde documentos importantes y no responde a tiempo los
							correos clave. Esto está afectando tanto su desempeño como la confianza de sus clientes. Como su líder, ¿qué acciones llevarías a cabo para ayudarlo a desarrollar su autodisciplina?
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(!btn1);
								grabarSeleccionada('a) Proporcionarle un sistema de nomenclatura para organizar archivos y una guía para priorizar tareas.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Proporcionarle un sistema de nomenclatura para organizar archivos y una guía para priorizar tareas.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(!btn2);
								grabarSeleccionada('b) Incrementar la supervisión de su trabajo diario para evitar errores.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Incrementar la supervisión de su trabajo diario para evitar errores.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(!btn3);
								grabarSeleccionada('c) Ofrecerle capacitación en herramientas de productividad y establecer objetivos claros con plazos específicos.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Ofrecerle capacitación en herramientas de productividad y establecer objetivos claros con plazos específicos.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn4(!btn4);
								grabarSeleccionada('d) Aplicar medidas disciplinarias para que entienda la importancia de ser organizado.');
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Aplicar medidas disciplinarias para que entienda la importancia de ser organizado.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
